import { duplicateMetric } from '../../api/hooks/metric/useDuplicateMetric';
import { captureError } from '../../web-tracing';

const QUERY_BLOCK_REGEX = /;;;(.*);;;/g; // global regex to find all query blocks

async function refreshQueryBlockIds(description: string) {
	const matches = description.matchAll(QUERY_BLOCK_REGEX);
	if (!matches) {
		return description;
	}

	for (const match of matches) {
		if (match.length !== 2) {
			continue;
		}

		const existingMetricId = match[1];
		if (!existingMetricId) {
			continue;
		}

		try {
			const newMetric = await duplicateMetric(existingMetricId);
			description = description.replace(match[0], `;;;${newMetric.id};;;`);
		} catch (error) {
			captureError(error);
		}
	}

	return description;
}

export async function sanitizeTemplateRichTextField(field: string) {
	return await refreshQueryBlockIds(field);
}
